
import TextField from '@mui/material/TextField';
import Tooltip from '@mui/material/Tooltip';
import constants from '../../utils/constants';
import { ThemeProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { es } from 'date-fns/locale';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parse, format, isValid } from 'date-fns';

const index = ({
    value,
    className,
    mode,
    disabled,
    id,
    name,
    help,
    onChange,
    design,
    view,
    mandatory,
    isFullYear
}) => {

    const dateFormat = isFullYear ? 'dd/MM/yyyy' : 'dd/MM/yy';

    const datePlaceholder = isFullYear ? 'dd/mm/aaaa' : 'dd/mm/aa';

    const parsedDate = value
        ? parse(value, 'yyyy-MM-dd', new Date())
        : null;

    const handleChange = (date) => {

        if (date instanceof Date && isValid(date)) {

            const year = date.getFullYear();

            if (year >= 1000 && year <= 9999) {

                const formatted = format(date, 'yyyy-MM-dd');

                onChange(formatted);

            } else {

                onChange(null);
            }

        } else {

            onChange(null);
        }
    };

    const formatInputDate = (value) => {

        let numbers = value.replace(/\D/g, '');

     
        const maxLength = isFullYear ? 8 : 6;

        numbers = numbers.substring(0, maxLength);

      
        if (numbers.length > 4) {

            return `${numbers.substring(0, 2)}/${numbers.substring(2, 4)}/${numbers.substring(4)}`;

        }

       
        if (numbers.length > 2) {

            return `${numbers.substring(0, 2)}/${numbers.substring(2)}`;

        }

        return numbers;
    };

    const inputWidth = isFullYear ? '11ch' : '9ch';
    const minWidth = inputWidth;

    return (
        <ThemeProvider theme={constants.CUSTOM_MUI_TEXT_FIELD_THEME}>

            <LocalizationProvider
                dateAdapter={AdapterDateFns}
                adapterLocale={es}
            >

                <Tooltip title={help} placement="top">

                    <DatePicker
                        label={
                            design !== 'table'
                                ? <span>
                                    {name}
                                    {mandatory
                                        ? <span style={{ color: 'red' }}> *</span>
                                        : ''
                                    }
                                  </span>
                                : null
                        }
                        disabled={disabled}
                        value={parsedDate}
                        onChange={handleChange}
                        inputFormat={dateFormat}
                        showDaysOutsideCurrentMonth
                        disableMaskedInput
                        clearable
                        slots={{
                            actionBar: ({ actions: ['clear'] })
                        }}
                        disableOpenPicker={view === 'r' || view === 'd'}
                        renderInput={(params) => (

                            <TextField
                                {...params}
                                id={id}
                                className={className ?? undefined}
                                onChange={(e) => {

                                    const formatted = formatInputDate(
                                        e.target.value
                                    );

                                    e.target.value = formatted;

                                    params.inputProps?.onChange?.(e);
                                }}
                                InputLabelProps={{
                                    ...params.InputLabelProps,
                                    shrink: true,
                                    style: {
                                        fontSize: 'inherit',
                                        lineHeight: 'inherit'
                                    }
                                }}
                                inputProps={{
                                    ...params.inputProps,
                                    readOnly: mode,
                                    placeholder: datePlaceholder,
                                    style: {
                                        ...params.inputProps.style,
                                        height: '1px',
                                        minWidth,
                                        width: inputWidth,
                                        fontSize: 'inherit',
                                        fontWeight: '600',
                                        lineHeight: 'inherit',
                                        paddingRight: '0px',
                                        paddingLeft: '8px',
                                        fontVariantNumeric: 'tabular-nums'
                                    }
                                }}
                            />

                        )}
                    />

                </Tooltip>

            </LocalizationProvider>

        </ThemeProvider>
    );
};

export default index;
